import type { ReactNode } from "react";
import Button, { ButtonProps } from "react-bootstrap/Button";
import getClasses from "utils/getClasses";
import styles from "./CheckboxDropdown.module.scss";

type Props = {
  Checkbox?: ReactNode;
  Label?: ReactNode;
} & ButtonProps;
const CheckboxDropdown = ({ Checkbox, Label, ...rest }: Props) => {
  return (
    <Button
      {...(Checkbox && {
        as: "label",
      })}
      className={getClasses(
        styles["checkbox-dropdown"],
        rest.disabled && styles["checkbox-dropdown--disabled"],
      )}
      variant={"link"}
      {...rest}
    >
      {Checkbox && (
        <div className={styles["checkbox-dropdown__checkbox"]}>{Checkbox}</div>
      )}
      {Label && (
        <span className={styles["checkbox-dropdown__label"]}>{Label}</span>
      )}
    </Button>
  );
};

export default CheckboxDropdown;
